namespace SPA
{
	export namespace BWS
	{
		export class Page
			extends ui.tab.TabHTMLPresentation
			{
				private MForm: 								ui.Form.Form;
				private MOrderBox: 						ui.Box.Box;
				private MAddressBox: 					ui.Box.Box;
				private MHistorieBox:					ui.Box.Box;
				private MList: 								SPA.gui.Listing<Wollmilch.BWS.IBWS>;
				private MData: 								Wollmilch.BWS.IBWS[][];
				private ResultText:						JQuery;

				private BWSObject:						Wollmilch.BWS.IBWS;
				private HTMLForm: 						JQuery;

				public constructor( BWSData: Wollmilch.BWS.IBWS )
				{
					super();

					this.Initialize( {} );

					this.MData = new Array();

					this.MOrderBox = new ui.Box.Box();
					this.MOrderBox.addTitle( app.getMessage( 'BWS.GENERAL.boxtitleOrder' ) );
					this.MOrderBox.rebuild();

					this.MAddressBox = new ui.Box.Box();
					this.MAddressBox.addTitle( app.getMessage( 'BWS.GENERAL.boxtitleAddress' ) );
					this.MAddressBox.rebuild();

					this.MHistorieBox = new ui.Box.Box();
					this.MHistorieBox.addTitle( app.getMessage( 'BWS.GENERAL.boxtitleHistorie' ) );
					this.MHistorieBox.rebuild();

					this.HTMLForm = $( document.createElement( 'form' ) );
					this.BWSObject = BWSData;

					this.ResultText = ui.$$.div();

					this.MForm = new ui.Form.Form(
					{
						action: '',
						classes: [ 'form-horizontal' ],
						method: 'POST',
						notSwitchable: true,
						submit: ( methode: ui.Form.FormMethod, action: string, parameter: ui.Form.IFormParameter ) => { /* */ },
					},
					);

					this.Root().append(
						ui.$$.div().addClass( 'row' )
							.append( ui.$$.div().addClass( 'col-sm-12 col-md-6' )
								.append( this.MOrderBox.Root() ),
							)
							.append( ui.$$.div().addClass( 'col-sm-12 col-md-6' )
								.append( this.MAddressBox.Root() ),
							),
					);
					this.Root().append(
						ui.$$.div().addClass( 'row' )
							.append( ui.$$.div().addClass( 'col-sm-12 col-md-12' )
								.append( this.MHistorieBox.Root() ),
							),
					);

					this.append( this.MForm );
					this.MForm.Initialize();

					this.MForm.appendTo( this.MOrderBox );
					this.rebuild( this.Root() );

					this.MList = new SPA.gui.Listing<Wollmilch.BWS.IBWS>(
						new SPA.BWS.data.BWSHistorieTableDataModel(
						{
							header: true,
							headerEnd: true,
							style:
							{
								condense: true,
								hover: true,
								stripes: true,
							},
						},
						),
						15,
						( list: SPA.gui.Listing<Wollmilch.BWS.IBWS>, count: number, page: number ): void =>
						{
							count = clamp( count, 5, 50 );

							const idx = this.MData.findIndex( ( value, index ) =>
							{
								return index === page && value !== undefined;
							},
							);

							if ( idx > -1 )
							{
								list.Content().Data( this.MData[ idx ] );
								list.Content().rebuild();

								return;
							}

							new Wollmilch.AJAX(
								{
									on:
									{
										success: ( text: string ): void =>
										{
											let obj = null;
											try
											{
												obj = Wollmilch.jsonize( text );
											}
											catch ( e )
											{
												app.addNotify(
												{
													body: [ ui.text( app.getMessage( 'BWS.ERROR.no_json' ) ) ],
													context: 'warning',
													timeout: Number(app.getConfigValue("ToastTimeout")),
													title: [ ui.h( 3, app.getMessage( 'BWS.ERROR.title' ) ) ],
												} );
												return;
											}

											if ( !obj || !obj.success )
											{
												app.addNotify(
												{
													body: [ ui.text( app.getMessage( 'BWS.ERROR.no_success' ) ) ],
													context: 'info',
													timeout: Number(app.getConfigValue("ToastTimeout")),
													title: [ ui.h( 3, app.getMessage( 'BWS.ERROR.title' ) ) ],
												} );
												return;
											}

											list.Content().Data( obj.data );
											list.Content().rebuild();

											list.SetPage( page, obj.count );

											this.MData[ page ] = obj.data;
										},
									},
									url: 'BWS/listhistorie/'
										+ encodeURIComponent( btoa( BWSData.ObjectNumber ) ) + '/limit/' + count + '/page/' + page,
								},
								Wollmilch.AJAXCallbase_e.BWS,
							).send();
						},
					);

					this.MList.rebuild( this.Root() );
					this.MHistorieBox.append( this.MList );

					this.readLoginDataFromDB();

					this.rebuild( this.Root() );
				}

				public rebuild( root: JQuery|ui.base.BaseHTMLElement ): Page
				{
					super.rebuild( root );

					return this;
				}

				private addObjDataInput( input: ui.Form.BasicInputField, baseclass: string[] ): void {
					this.MForm.Input( input ); input.Base().addClass( baseclass.join( ' ' ) );
				}

				private readLoginDataFromDB(): void
				{
					new Wollmilch.AJAX(
					{
						method: 'GET',
						on:
						{
							success: ( text: string ): void =>
							{
								let obj = null;
								try
								{
									obj = Wollmilch.jsonize( text );
								}
								catch ( e )
								{
									app.addNotify(
									{
										body: [ ui.text( app.getMessage( 'BWS.ERROR.no_json' ) ) ],
										context: 'danger',
										timeout: Number(app.getConfigValue("ToastTimeout")),
										title: [ ui.h( 4, app.getMessage( 'BWS.ERROR.title' ) ) ],
									} );
									return;
								}

								if ( obj && !obj.success )
								{
									app.addNotify(
									{
										body: [ ui.text( app.getMessage( 'BWS.ERROR.no_success' ) ) ],
										context: 'danger',
										timeout: Number(app.getConfigValue("ToastTimeout")),
										title: [ ui.h( 4, app.getMessage( 'BWS.ERROR.title' ) ) ],
									} );
									return;
								}

								if ( obj != null )
								{
									this.buildNewOrderForm();
									this.buildAddressForm();
									this.buildObjectForm();
									this.buildNewBWSForm( obj.data );
								}
							},
						},
						url: 'BWS/loadLoginData',
					},
					Wollmilch.AJAXCallbase_e.BWS,
					).send();
				}

				private buildObjectForm(): void
				{
					let NHKimg = 'no.nhk.pic';
					if ( this.BWSObject.BWS )
					{
						NHKimg = this.BWSObject.BWS.NHK2010.typ;
					}
					NHKimg = 'app/asset/brw/' + NHKimg.replace( ".", "_") + '.png';

					let fg = ui.$$.div()
					.append( ui.$$.hr() )
					.addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( app.getMessage( 'BWS.GENERAL.object' ) )
							.addClass( 'control-label col-xs-12 col-md-4' ) )
						.append( ui.$$.img()
							.attr('src', NHKimg )
							.css('width', 'auto')
							.css('height', '60px')
							.css('float', 'left')
							.addClass( 'control-label col-xs-12 col-md-2' ) )
						.append( ui.$$.text( this.BWSObject.BWS ? 'Baujahr ' + this.BWSObject.BWS.buildyear.toString() : '' )
							.addClass( 'control-label col-xs-12 col-md-2' ) )
						.append( ui.$$.br() )
						.append( ui.$$.text( this.BWSObject.BWS
								? 'Standardstufe ' + this.BWSObject.BWS.NHK2010.equipment.toString() : '' )
							.addClass( 'control-label col-xs-12 col-md-2' ) )
						.append( ui.$$.br() )
						.append( ui.$$.text( app.getMessage( 'BWS.GENERAL.bruttoarea' ) + (this.BWSObject.BWS
							? this.BWSObject.BWS.plotarea.toString() + app.getMessage( 'BWS.GENERAL.area' ) : '' ) )
							.addClass( 'control-label col-xs-12 col-md-8' ) )
						.appendTo( this.MOrderBox.Root() );

					fg = ui.$$.div()
					.addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( app.getMessage( 'BWS.GENERAL.estimatedprice' ) )
							.addClass( 'control-label col-xs-12 col-md-4' ) )
						.append( ui.$$.text( this.BWSObject.BWS
							? this.BWSObject.BWS.estimatedprice.toString() + app.getMessage( 'BWS.GENERAL.currency' ) : '' )
							.addClass( 'control-label col-xs-12 col-md-8' ),
						)
						.appendTo( this.MOrderBox.Root() );
				}

				private buildAddressForm(): void
				{
					let fg = ui.$$.div()
					.addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( app.getMessage( 'BWS.INPUTS.sections.owner' ) )
							.addClass( 'control-label col-xs-12 col-md-4' ) )
						.append( ui.$$.text( this.BWSObject.Owner
								? ( this.BWSObject.Owner.salutation + ' ' + this.BWSObject.Owner.name + ' ' + this.BWSObject.Owner.surname )
								: '',
						)
							.addClass( 'control-label col-xs-12 col-md-8' ) )
						.appendTo( this.MAddressBox.Root() );

					fg = ui.$$.div()
					.addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( '' )
							.addClass( 'control-label col-xs-12 col-md-4' ) )
						.append( ui.$$.text( this.BWSObject.Owner
								? (this.BWSObject.Owner.Address.street + ' ' + this.BWSObject.Owner.Address.housenumber )
								: '',
						)
							.addClass( 'control-label col-xs-12 col-md-8' ) )
						.appendTo( this.MAddressBox.Root() );

					fg = ui.$$.div()
					.addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( '' )
							.addClass( 'control-label col-xs-12 col-md-4' ) )
						.append( ui.$$.text( this.BWSObject.Owner
								? (this.BWSObject.Owner.Address.postalcode + ' ' + this.BWSObject.Owner.Address.city )
								: '',
						)
							.addClass( 'control-label col-xs-12 col-md-8' ) )
						.appendTo( this.MAddressBox.Root() );

					// @ts-ignore
					const gender = ( this.BWSObject.Customer && this.BWSObject.Customer.Gender === 'm' ) ? 'Herr' : 'Frau';
					fg = ui.$$.div()
					.addClass( 'form-group clearfix' )
						.append( ui.$$.hr() )
						.append( ui.$$.label().text( app.getMessage( 'BWS.INPUTS.sections.customer' ) )
							.addClass( 'control-label col-xs-12 col-md-4' ) )
						.append( ui.$$.text( this.BWSObject.Customer
							// @ts-ignore
							? gender + ' ' + this.BWSObject.Customer.Name + ' ' + this.BWSObject.Customer.Surname
							: 'no Customer given',
						 )
							.addClass( 'control-label col-xs-12 col-md-8' ) )
						.appendTo( this.MAddressBox.Root() );

					fg = ui.$$.div()
					.addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( '' )
							.addClass( 'control-label col-xs-12 col-md-4' ) )
						.append( ui.$$.text( this.BWSObject.Customer
							// @ts-ignore
							? this.BWSObject.Customer.Address[0].Street + ' ' + this.BWSObject.Customer.Address[0].HouseNumber
							: 'no Customer given',
						 )
							.addClass( 'control-label col-xs-12 col-md-8' ) )
						.appendTo( this.MAddressBox.Root() );

					fg = ui.$$.div()
					.addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( '' )
							.addClass( 'control-label col-xs-12 col-md-4' ) )
						.append( ui.$$.text( this.BWSObject.Customer
							// @ts-ignore
							? this.BWSObject.Customer.Address[0].PostalCode + ' ' + this.BWSObject.Customer.Address[0].City
							: 'no Customer given',
						 )
							.addClass( 'control-label col-xs-12 col-md-8' ) )
						.appendTo( this.MAddressBox.Root() );
				}

				private buildNewOrderForm(): void
				{
					new SPA.Navigation.BreadCrumb( this.BWSObject.ObjectNumber ).rebuild( this.MOrderBox );

					let fg = ui.$$.div()
					.addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( '' ).addClass( 'control-label col-xs-12 col-md-4' ) )
						.append( ui.$$.text( this.BWSObject.Object ? this.BWSObject.Object.Address.display : 'no address-data' )
							.addClass( 'control-label col-xs-12 col-md-8' ),
						)
						.appendTo( this.MOrderBox.Root() );

					fg = ui.$$.div()
					.addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( app.getMessage( 'BWS.TABLE.objectNumber' ) )
							.addClass( 'control-label col-xs-12 col-md-4' ),
						)
						.append( ui.$$.text( this.BWSObject.ObjectNumber ).addClass( 'control-label col-xs-12 col-md-8' ) )
						.appendTo( this.MOrderBox.Root() );

					fg = ui.$$.div()
					.addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( app.getMessage( 'BWS.TABLE.CaseNumber' ) )
							.addClass( 'control-label col-xs-12 col-md-4' ),
						)
						.append( ui.$$
							.text( this.BWSObject.caseNumber ? this.BWSObject.caseNumber : app.getMessage( 'BWS.TABLE.not_founded' ) )
							.addClass( 'control-label col-xs-12 col-md-8' ),
						)
						.appendTo( this.MOrderBox.Root() );
				}

				private buildNewBWSForm( obj: Wollmilch.BWS.ILogin ): void
				{
					this.addObjDataInput( new ui.Form.HiddenTextInput( obj.login, 'login' ), [] );
					this.addObjDataInput( new ui.Form.HiddenTextInput( obj.username, 'username' ), [] );
					this.addObjDataInput( new ui.Form.HiddenTextInput( obj.password, 'password' ), [] );
					this.addObjDataInput( new ui.Form.HiddenTextInput( obj.token, 'token' ), [] );

					this.append( this.HTMLForm );
					this.HTMLForm	.attr( 'method', 'POST' )
												.attr( 'target', '4171667b-32a4-43a9-9fb7-c627b622fa04' );

					$( new Button(
						{
							on:
							{
								click: () =>
								{
									this.addObjDataInput( new ui.Form.HiddenTextInput(
										encodeURIComponent( btoa( this.BWSObject.ObjectNumber ) ),
										'objectNumber' ), [],
									);

									this.addObjDataInput( new ui.Form.HiddenTextInput(
										app.getAuthenticationManager().getAuthToken(),
										'WMSAuthToken' ), [],
									);

									this.addObjDataInput( new ui.Form.HiddenTextInput(
										encodeURIComponent( btoa( this.BWSObject.caseNumber ? this.BWSObject.caseNumber : '' ) ),
										'caseNumber' ), [],
									);

									if ( this.BWSObject.caseNumber === 'not given yet' )
									{
										// update, saved in WMS, not saved in BWS
										this.addObjDataInput( new ui.Form.HiddenTextInput(
											this.BWSObject.Object ? this.BWSObject.Object.Address.Street : '', 'Address_Street' ), [] );
										this.addObjDataInput( new ui.Form.HiddenTextInput(
											this.BWSObject.Object ? this.BWSObject.Object.Address.HouseNumber : '', 'Address_Housenumber' ), [] );
										this.addObjDataInput( new ui.Form.HiddenTextInput(
											this.BWSObject.Object ? this.BWSObject.Object.Address.PostalCode : '', 'Address_Postalcode' ), [] );
										this.addObjDataInput( new ui.Form.HiddenTextInput(
											this.BWSObject.Object ? this.BWSObject.Object.Address.City : '', 'Address_City' ), [] );

										this.addObjDataInput( new ui.Form.HiddenTextInput(
											// @ts-ignore
											( this.BWSObject.Customer && this.BWSObject.Customer.Gender === 'm'  )
												? 'Herr' : 'Frau', 'Customer_Salutation' ), [] );
										this.addObjDataInput( new ui.Form.HiddenTextInput(
											this.BWSObject.Customer ? this.BWSObject.Customer.Name : '', 'Customer_Firstname' ), [] );
										this.addObjDataInput( new ui.Form.HiddenTextInput(
											// @ts-ignore
											this.BWSObject.Customer ? this.BWSObject.Customer.Surname : '', 'Customer_Surname' ), [] );

										this.addObjDataInput( new ui.Form.HiddenTextInput(
											// @ts-ignore
											this.BWSObject.Customer ? this.BWSObject.Customer.Address[0].Street : '', 'Customer_Street' ), [] );
										this.addObjDataInput( new ui.Form.HiddenTextInput(
											// @ts-ignore
											this.BWSObject.Customer ? this.BWSObject.Customer.Address[0].HouseNumber : '', 'Customer_Housenumber' ),
											[] );
										this.addObjDataInput( new ui.Form.HiddenTextInput(
											// @ts-ignore
											this.BWSObject.Customer ? this.BWSObject.Customer.Address[0].PostalCode : '', 'Customer_Postalcode' ), [] );
										this.addObjDataInput( new ui.Form.HiddenTextInput(
											// @ts-ignore
											this.BWSObject.Customer ? this.BWSObject.Customer.Address[0].City : '', 'Customer_City' ), [] );

										this.addObjDataInput( new ui.Form.HiddenTextInput(
											this.BWSObject.Owner ? this.BWSObject.Owner.salutation : '', 'Owner_Salutation' ), [] );
										this.addObjDataInput( new ui.Form.HiddenTextInput(
											this.BWSObject.Owner ? this.BWSObject.Owner.name : '', 'Owner_Firstname' ), [] );
										this.addObjDataInput( new ui.Form.HiddenTextInput(
											this.BWSObject.Owner ? this.BWSObject.Owner.surname : '', 'Owner_Surname' ), [] );
										this.addObjDataInput( new ui.Form.HiddenTextInput(
											this.BWSObject.Owner ? this.BWSObject.Owner.Address.street : '', 'Owner_Street' ), [] );
										this.addObjDataInput( new ui.Form.HiddenTextInput(
											this.BWSObject.Owner ? this.BWSObject.Owner.Address.housenumber : '', 'Owner_Housenumber' ), [] );
										this.addObjDataInput( new ui.Form.HiddenTextInput(
											this.BWSObject.Owner ? this.BWSObject.Owner.Address.postalcode : '', 'Owner_Postalcode' ), [] );
										this.addObjDataInput( new ui.Form.HiddenTextInput(
											this.BWSObject.Owner ? this.BWSObject.Owner.Address.city : '', 'Owner_City' ), [] );

										this.addObjDataInput( new ui.Form.HiddenTextInput(
											this.BWSObject.BWS ? this.BWSObject.BWS.estimatedprice : '', 'Object_EstimatedPrice' ), [] );

										this.addObjDataInput( new ui.Form.HiddenTextInput(
											this.BWSObject.BWS ? this.BWSObject.BWS.plotarea : '', 'Object_Plotarea' ), [] );
										this.addObjDataInput( new ui.Form.HiddenTextInput(
											this.BWSObject.BWS ? this.BWSObject.BWS.buildyear : '', 'Object_Buildingyear' ), [] );
										this.addObjDataInput( new ui.Form.HiddenTextInput(
											this.BWSObject.BWS ? this.BWSObject.BWS.bruttoarea : '', 'Object_Area' ), [] );

										this.addObjDataInput( new ui.Form.HiddenTextInput(
											this.BWSObject.BWS ? this.BWSObject.BWS.NHK2010.typ : '', 'NHK2010' ), [] );
										this.addObjDataInput( new ui.Form.HiddenTextInput(
											this.BWSObject.BWS ? this.BWSObject.BWS.NHK2010.equipment : '', 'NHK_E' ), [] );

										this.HTMLForm.attr( 'action', 'http://192.168.0.201/test_bws_wms/login_WMS.php' );
									}
									else
									{
										// load a saved one
										this.HTMLForm.attr( 'action', 'http://192.168.0.201/test_bws_wms/laden_WMS.php' );
									}

									this.HTMLForm = this.convertIntoPostForm( this.MForm, this.HTMLForm );

									this.HTMLForm.submit();
								},
							},
							style: 'success',
							title: app.getMessage( 'BWS.LABEL.btnShow' ),
						},
						).getElement(),
					).appendTo( this.HTMLForm );

					this.MHistorieBox.append( this.HTMLForm );
				}

				private convertIntoPostForm( MForm: ui.Form.Form, myForm: JQuery ): JQuery
				{
					const field = MForm.Input();

					Object.keys( field ).forEach( function( key )
					{
						const newField							= document.createElement( 'input' );

						newField.type 							= 'text';
						// @ts-ignore
						newField.name 							= field[key].Name.toString();
						newField.value 							= field[key].val();
						newField.style.display			= 'none';

						myForm.append( newField );
					});
					return myForm;
				}

			}
	}
}
